export function formatNumber(num) {
    // Handle undefined, null, or NaN values
    if (num === undefined || num === null || isNaN(num)) {
      return "0";
    }
    
    if (num < 1000) return num.toString();
  
    const units = ["k", "M", "B", "T"];
    let unitIndex = -1;
  
    while (num >= 1000 && unitIndex < units.length - 1) {
      num /= 1000;
      unitIndex++;
    }
  
    return `${parseFloat(num.toFixed(1))}${units[unitIndex]}`;
  }
  